"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function useDetectSticky() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    el = _ref.el,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 0 : _ref$distance;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isStuck = _useState2[0],
    setIsStuck = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    internalEl = _useState4[0],
    setInternalEl = _useState4[1];
  var _el = el || internalEl;
  (0, _react.useEffect)(function () {
    if (!_el) {
      return;
    }
    function detectSticky() {
      var _el$getBoundingClient = _el.getBoundingClientRect(),
        top = _el$getBoundingClient.top,
        left = _el$getBoundingClient.left;
      var axis = direction === 'vertical' ? top : left;
      var _isStuck = axis === distance;
      setIsStuck(_isStuck);
    }
    detectSticky();
    var controller = new AbortController();
    window.addEventListener('scroll', detectSticky, {
      signal: controller.signal
    });
    return function () {
      return controller.abort();
    };
  }, [_el, direction, distance]);
  return {
    isStuck: isStuck,
    el: _el,
    setEl: setInternalEl
  };
}
var _default = exports["default"] = useDetectSticky;
//# sourceMappingURL=useDetectSticky.js.map